"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkToStacked = void 0;
const react_1 = __importStar(require("react"));
const gatsby_1 = require("gatsby");
const hooks_1 = require("./hooks");
exports.LinkToStacked = react_1.default.forwardRef((_a, ref) => {
  var {
      to,
      onClick,
      onMouseLeave,
      onMouseEnter
    } = _a,
    restProps = __rest(_a, ["to", "onClick", "onMouseLeave", "onMouseEnter"]);
  const [,,, navigateToStackedPage, highlightStackedPage] = hooks_1.useStackedPage();
  const onClickHandler = react_1.useCallback(ev => {
    ev.preventDefault();
    if (onClick) {
      onClick(ev);
    }
    if (ev.metaKey || ev.ctrlKey) {
      window.open(gatsby_1.withPrefix(to), "_blank");
    } else {
      navigateToStackedPage(to);
    }
  }, [navigateToStackedPage, to, onClick]);
  const onMouseEnterHandler = react_1.useCallback(ev => {
    highlightStackedPage(to, true);
    if (onMouseEnter) {
      onMouseEnter(ev);
    }
  }, [to, onMouseEnter, highlightStackedPage]);
  const onMouseLeaveHandler = react_1.useCallback(ev => {
    highlightStackedPage(to, false);
    if (onMouseLeave) {
      onMouseLeave(ev);
    }
  }, [to, onMouseLeave, highlightStackedPage]);
  return react_1.default.createElement(gatsby_1.Link, Object.assign({}, restProps, {
    to: to /*
           // @ts-ignore */,
    ref: ref,
    onClick: onClickHandler,
    onMouseEnter: onMouseEnterHandler,
    onMouseLeave: onMouseLeaveHandler
  }));
});